import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BreakPoints, useBreakpoint } from '@front-core/utils';
import { useMemo } from 'react';
import { ComposedChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import { DateTimeHelper } from '@shared/lib/helpers/dateTime';
import { useAppSelector } from '@shared/lib/hooks/useAppSelector';
import styles from './chart.scss';
import CustomTooltip from './tooltip';
const Chart = () => {
    const media = useAppSelector(state => state.ui.media);
    const dealsStats = useAppSelector(state => { var _a; return (_a = state.agents) === null || _a === void 0 ? void 0 : _a.dealsStats; });
    const breakpoint = useBreakpoint(media === BreakPoints.MOBILE ? BreakPoints.MOBILE : BreakPoints.DESKTOP);
    const isMobile = breakpoint === BreakPoints.MOBILE;
    const interval = useMemo(() => {
        switch (breakpoint) {
            case BreakPoints.MOBILE:
                return 4;
            case BreakPoints.TABLET_PORTRAIT:
            case BreakPoints.TABLET_LANDSCAPE:
                return 2;
            case BreakPoints.DESKTOP:
                return 0;
            default:
                return 0;
        }
    }, [breakpoint]);
    const getDealsData = (data) => data.map(item => {
        const { date, dealsCount } = item;
        const slicedDate = DateTimeHelper.format(date, 'MMM YY').replace('.', '');
        const formattedDate = slicedDate.indexOf(' ');
        return {
            date: formattedDate === 4 ? slicedDate.slice(0, 3) + slicedDate.slice(4) : slicedDate,
            dealsCount
        };
    });
    return _jsx("div", { className: styles.chart, "data-sentry-component": "Chart", "data-sentry-source-file": "index.tsx", children: _jsx(ResponsiveContainer, { width: "99%", height: 180, "data-sentry-element": "ResponsiveContainer", "data-sentry-source-file": "index.tsx", children: _jsxs(ComposedChart, { data: getDealsData(dealsStats || []), margin: {
                    left: -38,
                    bottom: 0,
                    top: 28
                }, "data-sentry-element": "ComposedChart", "data-sentry-source-file": "index.tsx", children: [_jsx(XAxis, { dataKey: "date", interval: interval, tickLine: false, stroke: styles.secondaryColor, strokeDasharray: "2 2", tick: {
                            transform: 'translate(0, 6)'
                        }, "data-sentry-element": "XAxis", "data-sentry-source-file": "index.tsx" }), _jsx(YAxis, { tickLine: false, tick: {
                            textAnchor: 'middle',
                            strokeWidth: 0
                        }, axisLine: false, className: styles.axis, allowDecimals: false, "data-sentry-element": "YAxis", "data-sentry-source-file": "index.tsx" }), _jsx(Tooltip, { position: {
                            y: 0
                        }, content: _jsx(CustomTooltip, {}), "data-sentry-element": "Tooltip", "data-sentry-source-file": "index.tsx" }), _jsx(CartesianGrid, { stroke: styles.greyColor, strokeDasharray: "2 2", vertical: false, "data-sentry-element": "CartesianGrid", "data-sentry-source-file": "index.tsx" }), _jsx(Bar, { dataKey: "dealsCount", barSize: isMobile ? 16 : 36, fill: styles.greenColor, radius: isMobile ? [10, 10, 0, 0] : [5, 5, 0, 0], "data-sentry-element": "Bar", "data-sentry-source-file": "index.tsx" })] }) }) });
};
export default Chart;
